import { ID } from "@nova/constants"
import { useTranslation } from "@nova/use-translation"
import classNames from "classnames"
import { forwardRef, memo, useState } from "react"

type FlyoutMenuTabProps = {
    id?: string
    title: string
    isActive?: boolean
    isSelectable: boolean
    onTabClick?: (id: ID) => void
} & React.HTMLAttributes<HTMLDivElement>

const FlyoutMenuTab = memo(
    forwardRef<HTMLDivElement, FlyoutMenuTabProps>((props, ref) => {
        const { id, title, isActive, isSelectable, onTabClick } = props
        const { t } = useTranslation()
        const [isHovering, setIsHovering] = useState(false)

        return (
            <div
                className={classNames(
                    "h-8 px-4 py-1.5 flex justify-between items-center rounded-lg select-none",
                    {
                        "bg-transparent": !isHovering,
                        "bg-blue-500": isHovering && isSelectable,
                        "cursor-pointer": !!onTabClick,
                    }
                )}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                ref={ref}
                onClick={isSelectable && id && onTabClick ? () => onTabClick(id) : undefined}
            >
                <small
                    className={classNames("overflow-hidden text-ellipsis whitespace-nowrap", {
                        "text-gray-900": isHovering && isSelectable,
                        "text-gray-0": !isHovering && isSelectable,
                        "text-gray-300": !isSelectable,
                    })}
                >
                    {t(title)}
                </small>
                {isActive && (
                    <small
                        className={classNames("py-0.5 px-2 bg-gray-900 text-blue-500 rounded-xl")}
                    >
                        {t("Current")}
                    </small>
                )}
            </div>
        )
    })
)
FlyoutMenuTab.displayName = "FlyoutMenuTab"
export { FlyoutMenuTab }
